import React, { Component } from 'react';

function formValidationWrap(WhatComponentNeedsValidation) {
  const hoc = class extends Component {


    state = {
      errors: [],
      areErrorsVisible: false
    };
    errorsIncrement;

    setErrorsVisible = () => this.setState({ areErrorsVisible: true });
    errorMessages = (key, info = "") => {
      const t = this.t;
      const messages = {
        notEmpty: t("Este campo es obligatorio"),
        minChar: t("El campo debería contener mínimo") + " " + info + " " + t("caracteres"),
        maxChar: t("El campo debería contener como máximo") + " " + info + " " + t("caracteres"),
        equal: t("¡Ups!, los campos no coinciden"),
        contain: t("El campo debe contener") + " '" + info + "'"
      };
      this.errorsIncrement.push(messages[key]);
    };
    static defaultProps = {
      title: "",
      placeholder: "",
      minChar: null,
      maxChar: null,
      notEmpty: false,
      equal: null,
      contain: null
    };

    t = (text) => text;

    componentDidMount() {
      this.comproveErrors();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
      if (prevProps !== this.props) {
        this.comproveErrors()
      }
    }

    componentWillUnmount() {
      this.sendErrors(true);
    }

    comproveErrors = () => {
      this.errorsIncrement = [];
      this.notEmpty();
      this.minChar();
      this.maxChar();
      this.contain();
      this.equal();
      this.setState({ errors: this.errorsIncrement });
      this.sendErrors();
    };

    sendErrors = (isCorrect = (this.errorsIncrement.length < 1)) => {
      const { captureErrors, name } = this.props;
      captureErrors && captureErrors(name, isCorrect)
    };

    notEmpty = () => {
      const { value, notEmpty } = this.props;
      if (notEmpty && value === null && value.length < 1) {
        this.errorMessages("notEmpty");
      }
    };

    minChar = () => {
      const { value, minChar } = this.props;
      if (minChar !== null && value.length < minChar)
        this.errorMessages("minChar", minChar)
    };

    maxChar = () => {
      const { value, maxChar } = this.props;
      if (maxChar !== null && value.length > maxChar)
        this.errorMessages("maxChar", maxChar)
    };

    equal = () => {
      const { value, equal } = this.props;
      if (equal !== null && equal !== value)
        this.errorMessages("equal")
    };

    contain = () => {
      const { value, contain } = this.props;
      if (contain !== null && value.indexOf(contain) <= 0)
        this.errorMessages("contain", contain)
    };


    render() {
      const validation = {
        errors: this.state.errors,
        visible: this.state.areErrorsVisible
      };
      const t = this.t;
      return (
        <WhatComponentNeedsValidation
          validation={validation}
          setErrorsVisible={this.setErrorsVisible}
          t={t}
          {...this.props} />
      );
    }
  };

  hoc.displayName = (WhatComponentNeedsValidation.displayName || WhatComponentNeedsValidation.name);
  return hoc;
}

export { formValidationWrap };
